import { useEffect, useState } from "react";
import TopNav from "../components/TopNav";
import { Link, useSearchParams } from "react-router-dom";
import {
  List,
  Avatar,
  ListItemText,
  ListItemAvatar,
  FormControl,
  Button,
  ListItemButton,
  Chip,
  ListItemIcon,
  Menu,
  Checkbox,
  ListItem,
  Slider,
  Breadcrumbs,
  Typography,
  Link as MUILink,
  ButtonGroup,
} from "@mui/material";
import { AddCircle, FilterList } from "@mui/icons-material";
import utilStyle from "./Utils.module.css";
import { formatMoney, statusToColor } from "../utils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { APIProposal, getAllProposals, getProposal } from "../api/proposals";
import SplitPageView from "../components/SplitPageView";
import ProductDetailsPage from "./ProductDetailsPage";
import ProposalDetailsPage from "./ProposalDetailsPage";
import { APICustomer, getCustomer } from "../api/customers";

function ProposalListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [proposalsData, setProposalsData] = useState<APIProposal[]>([]);
  const [curProposal, setCurProposal] = useState<APIProposal | null>(null);
  const [_proposalsData, _setProposalsData] = useState<APIProposal[]>([]);
  const [curCustomer, setCurCustomer] = useState<APICustomer | null>(null);
  const [filter, setFilter] = useState<string | null>(null);

  useEffect(() => {
    getAllProposals().then((v) => _setProposalsData(v));
    if (!id) {
      setCurProposal(null);
    } else {
      getProposal(id).then((v) => setCurProposal(v));
    }
  }, [id]);

  useEffect(() => {
    if (!curProposal?.customerId) {
      setCurCustomer(null);
    }
    getCustomer(curProposal?.customerId).then((v) => setCurCustomer(v));
  }, [curProposal?.customerId]);

  useEffect(() => {
    let data = _proposalsData;
    if (filter) {
      data = data.filter((v) => v.status == filter);
    }
    setProposalsData(data);
  }, [filter, _proposalsData]);

  const updateFilter = (v: string) => () => {
    if (filter == v) {
      setFilter(null);
    } else {
      setFilter(v);
    }
  };

  return (
    <SplitPageView
      pageTitle="Proposals"
      contentList={
        <List style={{ padding: 0 }}>
          <ListItem>
            <ButtonGroup>
              <Button
                variant={filter == "LEAD" ? "contained" : "outlined"}
                onClick={updateFilter("LEAD")}
              >
                Lead
              </Button>
              <Button
                variant={filter == "QUOTED" ? "contained" : "outlined"}
                onClick={updateFilter("QUOTED")}
              >
                Quoted
              </Button>
              <Button
                variant={filter == "WON" ? "contained" : "outlined"}
                onClick={updateFilter("WON")}
              >
                Won
              </Button>
              <Button
                variant={filter == "DONE" ? "contained" : "outlined"}
                onClick={updateFilter("DONE")}
              >
                Done
              </Button>
            </ButtonGroup>
          </ListItem>
          <ListItemButton
            component={Link}
            to={`/proposals`}
            style={{ border: "0.5px solid #808080" }}
            selected={id === null}
          >
            <ListItemText primary="New Proposal" />
            <ListItemIcon>
              <AddCircle />
            </ListItemIcon>
          </ListItemButton>
          {proposalsData.map((proposal) => (
            <ListItemButton
              component={Link}
              to={`/proposals?id=${proposal.id}`}
              key={proposal.id}
              style={{ border: "0.5px solid #808080" }}
              selected={proposal.id === id}
            >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: "#606060" }}>
                  {proposal.firstName && proposal.firstName[0].toUpperCase()}
                  {proposal.lastName && proposal.lastName[0].toUpperCase()}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={`${proposal.firstName} ${proposal.lastName}`}
                secondary={`${proposal.addressLine1} ${proposal.city}, ${proposal.state}`}
              />
              <Chip
                label={formatMoney(proposal.totalAmount || 0)}
                color={statusToColor(proposal.status)}
                variant="outlined"
              />
            </ListItemButton>
          ))}
        </List>
      }
      breadcrumbs={
        id && (
          <Breadcrumbs aria-label="breadcrumb">
            <MUILink
              component={Link}
              underline="hover"
              color="inherit"
              to="/customers"
            >
              Customers
            </MUILink>
            <MUILink
              component={Link}
              underline="hover"
              color="inherit"
              to={`/customers?id=${curCustomer?.id}`}
            >
              {curCustomer?.firstName} {curCustomer?.lastName}
            </MUILink>
            <Typography sx={{ color: "text.primary" }}>Proposal</Typography>
          </Breadcrumbs>
        )
      }
      mainContent={<ProposalDetailsPage id={id || undefined} />}
    />
  );
}

export default ProposalListPage;
